import { render, staticRenderFns } from "./RegionBox.vue?vue&type=template&id=22832ded&scoped=true&"
import script from "./RegionBox.vue?vue&type=script&lang=js&"
export * from "./RegionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22832ded",
  null
  
)

export default component.exports